import OriginalBig from "big.js";

export const Big = number => OriginalBig(number || 0);
export const Float = bigNumber => parseFloat(bigNumber);
export const Int = bigNumber => parseInt(bigNumber, 10);
